import { render, staticRenderFns } from "./BtnDowload.vue?vue&type=template&id=28b1b01c"
import script from "./BtnDowload.vue?vue&type=script&lang=js"
export * from "./BtnDowload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports